import { authFetch } from 'auth/utils';
import { ProductCodesDTO, ProductCodesFilters } from '../models/productCodes';
import { mapKeys, omitBy, upperFirst } from 'lodash';
import qs from 'qs';
import { envVariables } from 'src/common/utils/envVariables';

const prepareProductCodesQuery = (filters?: ProductCodesFilters) => {
  if (!filters) {
    return '';
  }

  const cleanedFilters = omitBy(filters, (value) => {
    return !value;
  });

  const searchParams = mapKeys(cleanedFilters, (_, key) => upperFirst(key)) as Record<
    string,
    string
  >;

  return qs.stringify(searchParams);
};

export const fetchProductCodes = async (filters?: ProductCodesFilters, signal?: AbortSignal) => {
  const urlQuery = prepareProductCodesQuery(filters);
  const productCodesResponse = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_PRODUCT_CODES_API}?${urlQuery.toString()}`,
    { signal },
  );

  const productCodes: ProductCodesDTO = await productCodesResponse.json();

  return productCodes.items;
};
